import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";

const WarrantyPitchingOurTrackRecord = ({ promotionData }) => {
    const { highlights = [], footer = "", title = "", description = "" } = promotionData || {};

    const { info: leftInfo = "", value: leftValue = "", iconUrl: leftIcon = "" } = highlights[0] || {};
    const { info: rightInfo = "", value: rightValue = "", iconUrl: rightIcon = "" } = highlights[1] || {};

    if (highlights.length === 0) {
        return null;
    }

    return (
        <div styleName={"styles.outer"}>
            <p styleName={"styles.heading"}>{title}</p>
            <p styleName={"styles.subHeading"}>{description}</p>
            <div styleName={"styles.sectionWrapper"}>
                <div className="media" styleName={"styles.mediaContainer styles.firstChild"}>
                    <img src={leftIcon} />
                    <div className="media-body">
                        <p styleName={"styles.amount"}>{leftValue}</p>
                        <p styleName={"styles.sectionDetail"}>{leftInfo}</p>
                    </div>
                </div>
                <div className="media" styleName={"styles.mediaContainer"}>
                    <img src={rightIcon} />
                    <div className="media-body">
                        <p styleName={"styles.amount"}>{rightValue}</p>
                        <p styleName={"styles.sectionDetail"}>{rightInfo}</p>
                    </div>
                </div>
            </div>
            <p styleName={"styles.bottomText"}>{footer}</p>
        </div>
    );
};

WarrantyPitchingOurTrackRecord.propTypes = {
    promotionData: PropTypes.object
};

export default WarrantyPitchingOurTrackRecord;
